import * as React from 'react';

export default function AnotherApp() {
    return (
        <main style={{ padding: '1rem 0' }}>
            <h2>Another App</h2>
        </main>
    );
}
